export const FETCH_TICKETS_ANALYTIC   = 'FETCH_TICKETS_ANALYTIC';
export const FETCH_TICKET_ANALYTIC_LOGS   = 'FETCH_TICKET_ANALYTIC_LOGS';
export const CLEAN_TICKET_LOGS   = 'CLEAN_TICKET_LOGS';
